// Fire-and-forget referral click beacon. Called from anchor onClick handlers
// on the homepage rotator, navbar pill, and admin "Open Link" button.
//
// Uses navigator.sendBeacon when available (survives the navigation to the
// outbound target), with a fetch keepalive fallback for older browsers.
// Always resolves silently — a failed beacon must NEVER block or delay the
// user's click.
const API = process.env.REACT_APP_BACKEND_URL;

const trackReferralClick = (referralId) => {
  if (!referralId) return;
  const url = `${API}/api/referrals/${encodeURIComponent(referralId)}/click`;
  try {
    if (typeof navigator !== 'undefined' && typeof navigator.sendBeacon === 'function') {
      // Blob body ensures Content-Type is set on Beacon requests in Firefox.
      const ok = navigator.sendBeacon(url, new Blob([''], { type: 'text/plain' }));
      if (ok) return;
    }
  } catch (_) {
    // fall through to fetch
  }
  try {
    // keepalive lets the request complete after page unloads.
    fetch(url, { method: 'POST', keepalive: true, credentials: 'omit' }).catch(() => {});
  } catch (_) {
    /* swallow — beacons must never break UX */
  }
};

export default trackReferralClick;
